import { updateAboutById } from '../api';

const aboutArgs = (
  pt,
  es,
) => ({
  pt,
  es,
});

const updateAbout = (
  id,
  pt,
  es,
) => updateAboutById(
  id,
  aboutArgs(pt, es),
);

export default updateAbout;
